import React, { Component } from 'react';
import Loading from './Loading.js';


class Loadable extends Component {
	render() {
		if (this.props.ready)
			return <div className={"Loaded " + (this.props.className || "")}>{this.props.children}</div>;
		else
			return <div className={"Loading " + (this.props.className || "")}><Loading /></div>
	}
}

export default Loadable;
